import MxRadio, { MxRadioProps } from "@rf-l1/form/MxRadio";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";
import React from "react";

type omit = "name" | "value" | "onChange";
export type MxFormRadioFieldProps = Omit<MxRadioProps, omit>

const MxFormRadioField = (props: MxFormRadioFieldProps) => {
  const { onBlur, onChange, inputRef, name, value, invalid, disabled } =
    useMxFieldControllerContext();

  const onHandleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    onBlur(e);
    if (props.onBlur) {
      props.onBlur?.(e);
    }
  };

  return (
    <MxRadio
      {...props}
      onBlur={onHandleBlur}
      name={name}
      onChange={onChange}
      inputRef={inputRef}
      value={value as string | number}
      invalid={invalid}
      disabled={disabled || props.disabled}
    />
  );
};

export default MxFormRadioField;
